module.exports = __webpack_public_path__ + "static/media/dryer.b36ae02e.svg";